export const COMPANY_INFO = {
  name: 'Felt Right',
  address1: '860 W 14600 S Suite 1000',
  city: 'Bluffdale',
  state: 'UT',
  zip: '84065',
  get cityStateZip() { return `${this.city}, ${this.state} ${this.zip}` },
} as const

export const useConstants = () => {
  return {
    FELT_RIGHT_USER_COOKIE: 'felt_user'
  }
}